import React from "react";

export const LazySiteMapRoutes = React.lazy(() => import("./routes").then(m => ({ default: m.SiteMapRoutes })));

export const siteMapPathPrefix = "/__sitemap";
